function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.567 20.93l.846-.636c.57-.984 1.195-3.268 1.438-5.267-.283-.582-.6-1.058-.844-1.756-.127-.57-.222-1.64-.2-2.452-.075-.804.073-1.46-.223-2.422l-.275-.423c-.222.57-.465 1.343-.603 2.105-.032.708.116 1.46.18 2.18l.455 3.648c.052.73.02 1.385-.107 2.178l-.91 2.634C2.35 20.04 1.25 18.58.616 17.523c.17-.793-.096-1.597-.138-2.39L.023 12.15c-.105-1.544.17-2.317.413-3.438.2-.793.54-1.618.846-2.03.71-.667 1.66-.804 2.528-.815.867-3.882 3.32-5.765 6.43-5.86 3.47-.116 8.07 1.174 9.17 3.332.71 1.384.837 2.896.73 3.69-.052.54-.676 1.353-1.152 1.607 0 .275-.095.54-.01.815.253.518 1.46 1.798 1.66 2.21.16.497-.106.71-.317.836-.37.18-1.056.337-1.12.528-.084.275.15.57.276.888-.01.39-.392.35-.593.518.074.19.19.318.148.614-.083.222-.813.613-.887.814-.074.18.36 1.386-.846 1.83-.973.275-1.756-.254-2.634-.38-.434-.128-.825-.01-1.09.243-.327.39-.888 1.713-1.12 2.432-.244.656-.054 2.285.21 3.004.33.37.657.73.805 1.09-.963.243-3.988-.095-5.966-.73-1.353-.497-2.76-1.45-3.933-2.42z",
  className: "icon-sub-menu-one",
  opacity: 0.8,
  fill: "#99c647",
  fillRule: "evenodd",
  id: "path7"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.648.758L46.15 12.266 33.648 23.774v-5.69h-2.264l.01-.022c.18-.423.128-1.004.19-1.258.044-.423.657-.688.646-1.016.01-.127-.17-.254-.253-.39.21-.17.444-.19.55-.445.063-.307-.244-.667-.244-.92.19-.34.677-.318 1.016-.476.294-.223.326-.52.284-.762-.043-.233-1.323-1.81-1.513-2.295-.063-.52.413-2 .138-3.522-.043-.18-.096-.35-.16-.508v-.01h1.598z",
  className: "icon-sub-menu-three",
  opacity: 0.5,
  fill: "red",
  fillRule: "evenodd",
  id: "path11"
});

var SvgInsight = function SvgInsight(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "46.14991mm",
    height: "24.392952mm",
    viewBox: "0 0 46.14991 24.392952",
    id: "svg13",
    ref: svgRef
  }, props), _ref2, React.createElement("path", {
    clipPath: "",
    d: "m 82.376,5.51 c 8.133,-0.488 16.153,2.36 19.976,5.92 1.424,1.163 2.36,3 1.95,3.786 2.997,3.448 5.433,5.847 6.67,10.606 0.9,5.06 -0.675,9.97 -0.45,11.693 0.637,1.612 4.872,6.82 5.022,7.608 0.113,0.787 0.038,1.8 -0.937,2.51 -1.124,0.526 -2.773,0.45 -3.373,1.575 0,0.862 0.975,2.062 0.825,3.074 -0.377,0.824 -1.126,0.9 -1.84,1.46 0.264,0.45 0.863,0.863 0.826,1.313 0.037,1.05 -1.986,1.95 -2.136,3.336 -0.262,1.163 0.076,4.2 -1.46,5.36 -4.948,3.336 -14.542,-1.35 -15.592,0.076 -1.012,1.124 -0.337,6.11 -1.31,9.257 3.484,2.286 5.958,8.208 5.92,9.07 l -0.862,1.2 c 1.012,0.823 1.462,1.46 1.8,2.21 -6.635,2.06 -14.43,1.2 -20.014,0.15 l -0.487,-0.15 -2.174,-3.373 v -4.46 l -1.497,-6.784 -1.125,-0.413 c 0.413,-0.937 1.2,-1.5 1.237,-2.773 0.263,-2.136 -0.112,-4.198 0.375,-5.06 0.56,-0.412 8.73,0.525 11.692,-1.2 1.537,-1.236 0.712,-5.02 0.862,-7.232 0.113,-0.825 1.874,-1.274 2.136,-2.324 -0.112,-0.862 -0.787,-0.974 -0.637,-1.424 0.263,-0.712 1.162,-0.674 1.387,-1.237 0.187,-0.9 -0.637,-2.96 -0.525,-4.422 0.675,-0.485 5.397,0.377 6.222,-1.197 0.787,-2.286 -4.385,-8.32 -4.723,-10.044 0.113,-2.475 1.724,-3.937 1.537,-6.11 0.04,-2.85 -1.572,-6.784 -2.36,-10.157 l 1.687,-1.087 c 1.312,-0.75 1.125,-2.586 -0.15,-4.31 -1.5,-1.61 -4.047,-3.448 -7.046,-5.21 L 81.48,5.66 Z",
    transform: "matrix(0.28222,0,0,0.28222,-0.114,-0.11)",
    className: "icon-sub-menu-two",
    id: "path9",
    style: {
      opacity: 0.7,
      fill: "#8497b0",
      fillRule: "evenodd"
    }
  }), _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInsight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Insight.0ede8301.svg";
export { ForwardRef as ReactComponent };